import useController from "@hooks/useController";

export default function useSalonPaymentController(salonId: string | number): Customer.Controllers.SalonPayment {
    const controller = useController(`/api/customer/salons/${salonId}`)

    const discount = (code: string) => controller.get(`discount/${code}`)
    const order = (code?: string) => controller.post("order", { code })
    const capture = (orderId: string, code?: string) => controller.post(`order/${orderId}/capture`, { code })
    const stripe = (paymentMethodId: string, code?: string) => controller.post(`stripe`, { paymentMethodId, code })

    return { capture, discount, order, stripe }
}